// extracted by mini-css-extract-plugin
export default {"Questions":"Questions_Questions__8Sbno","Header":"Questions_Header__Jr7IU"};